import { useQuery } from '@tanstack/react-query';

import { MembershipDetailed } from 'src/features/membershipCloudUsers/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/retrieve_detailed/`;

type QueryFnType = typeof queryFn;

interface DTO {
    membershipId: string;
    parkingId: string;
}
const queryFn = ({ membershipId, parkingId }: DTO): Promise<MembershipDetailed> => {
    return axios.get(formatResourcePath(RESOURCE, { membershipId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetMembershipDetailed, RESOURCE as GET_MEMBERSHIP_DETAILED_RESOURCE };
